import React, { HTMLInputTypeAttribute } from "react";
import { baseFieldStyle } from "../../Utilities/customClassTypes";

interface FormInputProps {
  label: string;
  inputType?: HTMLInputTypeAttribute;
  inputName: string;
  errorMessage?: string;
  setFormValue: (key: string, value: string | number | boolean) => void;
}

const FormInput = ({
  inputType = "text",
  inputName,
  errorMessage,
  setFormValue,
}: FormInputProps): JSX.Element => {
  return (
    <input
      id="formInput"
      type={inputType}
      name={inputName}
      className={baseFieldStyle(!!errorMessage)}
      onChange={(event) => setFormValue(inputName, event.target.value)}
    />
  );
};

export default FormInput;
